import styled from 'styled-components';
import { backgroundAlt } from '../../variables';

const Wrapper = styled.footer`
  background: ${backgroundAlt};
  padding: 30px 15px;
  text-align: center;
`;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/Footer/Wrapper.js